import { useTranslate } from '@ur-solutions/react-hooks'
import React, { useState } from 'react'
import { LONG_COMMENT_THRESHOLD, type CommentEntry } from './types'

interface Props {
  entry: CommentEntry
}

export const ApprovalCommentRow: React.FC<Props> = ({ entry }) => {
  const t = useTranslate({
    driver: 'common.driver',
    leder: 'salary.leder',
    showMore: 'common.show-more',
    showLess: 'common.show-less',
    approvedBy: 'salary.approved-by',
  })

  const [expanded, setExpanded] = useState(false)
  const isLong = entry.text.length > LONG_COMMENT_THRESHOLD
  const roleLabel = entry.role === 'driver' ? t.driver : t.leder
  const roleColorClass =
    entry.role === 'driver' ? 'text-[#549DC2]' : 'text-primary'

  return (
    <div className="grid grid-cols-1 gap-1 border-b border-[#F3F3F3] px-4 py-3 last:border-b-0 md:grid-cols-[110px_70px_1fr] md:items-start md:gap-3.5 md:px-6 md:py-3.5">
      <div className="flex items-baseline gap-1.5 text-[13px] font-medium text-[#363639] md:block md:pt-px">
        <span>{entry.timeRange}</span>
        <span className={`text-[13px] font-bold md:hidden ${roleColorClass}`}>
          <span className="mx-1 font-normal text-[#9696A2]">·</span>
          {roleLabel}
        </span>
      </div>
      <div
        className={`hidden text-[13px] font-bold md:block md:pt-px ${roleColorClass}`}
      >
        {roleLabel}
      </div>
      <div className="flex min-w-0 flex-col gap-1">
        <div
          className={`text-[13px] leading-[1.45] break-words whitespace-pre-wrap text-[#363639] [overflow-wrap:anywhere] ${
            isLong && !expanded ? 'line-clamp-2' : ''
          }`}
        >
          {entry.text}
        </div>
        {entry.approverName && (
          <div className="text-[12px] text-[#9696A2]">
            {t.approvedBy}: {entry.approverName}
          </div>
        )}
        {isLong && (
          <button
            type="button"
            onClick={() => setExpanded(prev => !prev)}
            className="self-start cursor-pointer border-0 bg-transparent p-0 text-xs font-semibold text-[#549DC2] hover:underline"
          >
            {expanded ? t.showLess : t.showMore}
          </button>
        )}
      </div>
    </div>
  )
}
